import { RepairStatus } from '@geartracker/types';

import { createZodDto } from './zod';

import { z } from 'zod';

export const CreateRepairSchema = z.object({
  equipmentId: z.number().int(),
  // true -> quarantine (do not use), false -> minor defect, stays usable
  blocking: z.boolean().default(true),
  requiresReinspection: z.boolean().default(true),
  description: z.string().nullable().optional(),
  assignedToUserId: z.number().int().nullable().optional(),
  cost: z.number().int().nullable().optional(),
  filesIds: z.number().array().default([]),
  imagesIds: z.number().array().default([]),
});

// Status transitions and field edits. `equipmentId` is immutable once created.
export const UpdateRepairSchema = z.object({
  status: z.nativeEnum(RepairStatus).optional(),
  blocking: z.boolean().optional(),
  requiresReinspection: z.boolean().optional(),
  description: z.string().nullable().optional(),
  resolution: z.string().nullable().optional(),
  assignedToUserId: z.number().int().nullable().optional(),
  cost: z.number().int().nullable().optional(),
  filesIds: z.number().array().optional(),
  imagesIds: z.number().array().optional(),
});

export const RepairListQuerySchema = z.object({
  skip: z.coerce.number().int().min(0).default(0),
  take: z.coerce.number().int().min(1).max(500).default(100),
  status: z.nativeEnum(RepairStatus).optional(),
  openOnly: z.coerce.boolean().optional(),
  equipmentId: z.coerce.number().int().optional(),
});

export class CreateRepairDto extends createZodDto(CreateRepairSchema) {}

export class UpdateRepairDto extends createZodDto(UpdateRepairSchema) {}

export class RepairListQueryDto extends createZodDto(RepairListQuerySchema) {}
